export interface GeoCoordinatesRequest {
    provider: any;
    freeText?: string;
  }
  